import { BookingSummary, QuoteStatus } from '@jucy/rentals-api-client/rentals-api-v3';

export const filterSortBookingSummaries = (bookingSummaries?: BookingSummary[]) =>
    bookingSummaries
        ?.filter((s) =>
            Boolean(
                [QuoteStatus.Confirmed, QuoteStatus.Cancelled, QuoteStatus.OnRoad, QuoteStatus.Returned].includes(s.status) &&
                    s.pickUpDate &&
                    s.ref &&
                    !s.disableCheckIn
            )
        )
        .sort((a, b) => {
            let primarySort = 0;
            if (b.pickUpDate && a.pickUpDate) {
                primarySort = b.pickUpDate.getTime() - a.pickUpDate.getTime();
            }

            if (primarySort === 0) {
                return b.created.getTime() - a.created.getTime();
            }

            return primarySort;
        });
